<template>
    <div class="column is-one-third">
        <table class="table is-fullwidth">
            <tr>
                <th>Sub Total:</th>
                <td><input class="input" v-model="sub_total" type="number" :disabled="isLocked"></td>
            </tr>
            <tr>
                <th>Deposit Applied:</th>
                <td><input class="input" @keyup="calculateBalanceDue" v-model="deposit_applied" type="number" :disabled="isLocked"></td>
            </tr>
            <tr>
                <th>Balance Due:</th>
                <td><input class="input" v-model="balance_due" type="number" :disabled="isLocked"></td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        props:['car'],
        components: {

        },
        data () {
            return {

            }
        },
        computed: {
            isLocked() {
                return this.$store.getters.getProformaInvoiceLockedStatus
            },
            sub_total: {
                get() {
                    return this.$store.getters.getProformaInvoice.sub_total
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceFieldValue', { field: 'sub_total', value: value })
                }
            },
            deposit_applied: {
                get() {
                    return this.$store.getters.getProformaInvoice.deposit_applied
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceFieldValue', { field: 'deposit_applied', value: value })
                }
            },
            balance_due: {
                get() {
                    return this.$store.getters.getProformaInvoice.balance_due
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceFieldValue', { field: 'balance_due', value: value })
                }
            },
        },
		methods: {
            calculateBalanceDue() {
                let balanceDue = Number(this.sub_total) - Number(this.deposit_applied)
                this.$store.dispatch('changeProformaInvoiceFieldValue', { field: 'balance_due', value: balanceDue })
            }
		}
    }
</script>

<style scoped>
    th {
        font-size: small;
    }
</style>



// WEBPACK FOOTER //
// src/components/Cars/Columns/ProformaInvoice/ProformaInvoiceSubTotal.vue